<div>
<div class="table-responsive settings-table-shell settings-reference-table settings-user-management-table-shell rounded-4 border border-white border-opacity-10 d-none d-md-block">
    <div v-if="is_loading" class="d-flex align-items-center gap-3 text-white-50 p-3">
        <div class="spinner-border spinner-border-sm text-light" role="status" aria-hidden="true"></div>
        <span class="text-xs">Loading users...</span>
    </div>

    <div v-else-if="!users.length" class="text-center text-white py-4 text-xs">
        <div class="d-flex flex-column align-items-center justify-content-center py-4">
            <span class="d-inline-flex align-items-center justify-content-center rounded-circle border border-white border-opacity-10 bg-white bg-opacity-10 text-white mb-3" style="width: 2.5rem; height: 2.5rem;">
                <i class="bi bi-people-fill"></i>
            </span>
            <p class="text-white fw-semibold mb-1">No users available</p>
            <p class="text-white text-xs mb-0">Added users will appear here.</p>
        </div>
    </div>

    <table
        v-else
        class="table table-dark table-striped table-hover align-middle mb-0 global_data_table small settings-user-management-table"
        data-search-placeholder="Search users"
        data-non-orderable-targets="[6]"
        data-page-length="5"
        data-order-column="0"
        data-order-direction="asc"
    >
        <thead>
            <tr>
                <th scope="col" class="text-white fw-semibold small">User</th>
                <th scope="col" class="text-white fw-semibold small">Email</th>
                <th scope="col" class="text-white fw-semibold small">Role</th>
                <th scope="col" class="text-white fw-semibold small">Properties</th>
                <th scope="col" class="text-white fw-semibold small">Status</th>
                <th scope="col" class="text-white fw-semibold small">Last Login</th>
                <th scope="col" class="text-white fw-semibold small text-end">Actions</th>
            </tr>
        </thead>

        <tbody>
            <tr v-for="user in users" :key="user.id">
                <td data-label="Member" class="settings-user-member-cell">
                    <div class="d-flex align-items-center gap-2">
                        <span class="settings-user-avatar d-inline-flex align-items-center justify-content-center rounded-circle">
                            {{ get_initials(user) }}
                        </span>
                        <div class="d-flex flex-column gap-1">
                            <span class="text-white fw-semibold text-xs">{{ get_full_name(user) }}</span>
                            <span class="settings-user-mobile-email text-xs">{{ user.email || "-" }}</span>
                        </div>
                    </div>
                </td>
                <td data-label="Email" class="text-white fw-semibold text-xs settings-user-email-cell">{{ user.email || "-" }}</td>
                <td data-label="Role">
                    <span class="badge rounded-pill text-bg-info bg-opacity-25 border border-info border-opacity-25 small text-white">
                        {{ user.role || "-" }}
                    </span>
                </td>
                <td data-label="Properties" class="text-white text-xs settings-user-properties-cell">{{ get_property_summary(user) }}</td>
                <td data-label="Status">
                    <span
                        class="badge rounded-pill small text-white"
                        :class="user.is_active ? 'text-bg-success bg-opacity-25 border border-success border-opacity-25' : 'text-bg-secondary bg-opacity-25 border border-light border-opacity-10'"
                    >
                        {{ user.is_active ? "Active" : "Inactive" }}
                    </span>
                </td>
                <td data-label="Last Login" class="text-white text-xs settings-user-last-login-cell">
                    {{ get_last_login_label(user) }}
                </td>
                <td data-label="Actions" class="settings-user-actions-cell">
                    <div class="d-flex justify-content-end gap-2 flex-wrap">
                        <button
                            type="button"
                            class="btn btn-outline-light btn-sm rounded-3 d-inline-flex align-items-center justify-content-center gap-1 px-3 settings-user-edit-action"
                            @click="open_edit_user(user)"
                            aria-label="Edit user"
                        >
                            <i class="bi bi-pencil-square"></i>
                            <span class="text-xs">Edit</span>
                        </button>

                        <button
                            type="button"
                            :class="['btn btn-sm rounded-3 d-inline-flex align-items-center justify-content-center gap-1 px-3 settings-user-status-action', user.is_active ? 'btn-warning' : 'btn-success']"
                            @click="toggle_user_status(user)"
                            :disabled="is_busy || (is_current_user(user) && user.is_active) || (!user.is_active && !has_users_endpoint)"
                            :aria-label="user.is_active ? 'Deactivate user' : 'Activate user'"
                            :title="get_status_action_title(user)"
                        >
                            <span v-if="is_user_status_updating(user)" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            <span class="text-xs">{{ user.is_active ? "Deactivate" : "Activate" }}</span>
                        </button>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</div>

<div class="d-md-none">
    <div v-if="is_loading" class="glass-card text-white border border-white border-opacity-10 rounded-4">
        <div class="card-body d-flex align-items-center gap-3 text-white-50 p-3">
            <div class="spinner-border spinner-border-sm text-light" role="status" aria-hidden="true"></div>
            <span class="text-xs">Loading users...</span>
        </div>
    </div>

    <div v-else-if="!users.length" class="glass-card text-white border border-white border-opacity-10 rounded-4">
        <div class="card-body text-center py-5">
            <span class="d-inline-flex align-items-center justify-content-center rounded-circle border border-white border-opacity-10 bg-white bg-opacity-10 text-white mb-3" style="width: 2.5rem; height: 2.5rem;">
                <i class="bi bi-people-fill"></i>
            </span>
            <p class="text-white fw-semibold mb-1">No users available</p>
            <p class="text-white-50 text-xs mb-0">Added users will appear here.</p>
        </div>
    </div>

    <div v-else class="d-flex flex-column gap-3">
        <SettingsMobileListControls
            :search-value="mobile_search"
            search-placeholder="Search users"
            :current-page="mobile_page"
            :page-count="mobile_page_count"
            pagination-label="User pages"
            :show-pagination="false"
            @update:search-value="mobile_search = $event"
            @update:current-page="set_mobile_page"
        />

        <article
            v-for="user in paginated_mobile_users"
            :key="`mobile-user-${user.id || user.email}`"
            class="glass-card text-white border border-white border-opacity-10 rounded-4 shadow-sm"
        >
            <div class="card-body p-3">
                <div class="d-flex align-items-start justify-content-between gap-3 mb-3">
                    <div class="d-flex align-items-center gap-3 min-w-0">
                        <span class="settings-user-avatar d-inline-flex align-items-center justify-content-center rounded-circle flex-shrink-0">
                            {{ get_initials(user) }}
                        </span>
                        <div class="min-w-0">
                            <p class="text-uppercase text-primary fw-bold text-xs mb-1">Member</p>
                            <h6 class="fw-semibold mb-1 text-break">{{ get_full_name(user) }}</h6>
                            <p class="text-white-50 text-xs mb-0 text-break">{{ user.email || "-" }}</p>
                        </div>
                    </div>

                    <span
                        class="badge rounded-pill text-xs flex-shrink-0"
                        :class="user.is_active ? 'bg-success text-dark' : 'bg-secondary'"
                    >
                        {{ user.is_active ? "Active" : "Inactive" }}
                    </span>
                </div>

                <div class="row g-3">
                    <div class="col-12">
                        <p class="text-uppercase text-primary fw-bold text-xs mb-1">Role</p>
                        <span class="badge rounded-pill text-bg-info bg-opacity-25 border border-info border-opacity-25 small text-white">
                            {{ user.role || "-" }}
                        </span>
                    </div>

                    <div class="col-12">
                        <p class="text-uppercase text-primary fw-bold text-xs mb-1">Properties</p>
                        <p class="fw-semibold text-xs mb-0">{{ get_property_summary(user) }}</p>
                    </div>

                    <div class="col-12">
                        <p class="text-uppercase text-primary fw-bold text-xs mb-1">Last Login</p>
                        <p class="fw-semibold text-xs mb-0">{{ get_last_login_label(user) }}</p>
                    </div>

                    <div class="col-12">
                        <p class="text-uppercase text-primary fw-bold text-xs mb-2">Actions</p>
                        <div class="d-flex flex-wrap gap-2">
                            <button
                                type="button"
                                class="btn btn-outline-light btn-sm rounded-3 d-inline-flex align-items-center justify-content-center gap-2"
                                @click="open_edit_user(user)"
                                aria-label="Edit user"
                            >
                                <i class="bi bi-pencil-square"></i>
                                <span class="text-xs">Edit</span>
                            </button>

                            <button
                                type="button"
                                :class="['btn btn-sm rounded-3 d-inline-flex align-items-center justify-content-center gap-2', user.is_active ? 'btn-warning' : 'btn-success']"
                                @click="toggle_user_status(user)"
                                :disabled="is_busy || (is_current_user(user) && user.is_active) || (!user.is_active && !has_users_endpoint)"
                                :aria-label="user.is_active ? 'Deactivate user' : 'Activate user'"
                                :title="get_status_action_title(user)"
                            >
                                <span v-if="is_user_status_updating(user)" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                <span class="text-xs">{{ user.is_active ? "Deactivate" : "Activate" }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </article>

        <div v-if="!paginated_mobile_users.length" class="glass-card text-white border border-white border-opacity-10 rounded-4">
            <div class="card-body text-center py-4">
                <p class="text-white-50 text-xs mb-0">No matching users found.</p>
            </div>
        </div>

        <SettingsMobileListControls
            :search-value="mobile_search"
            :current-page="mobile_page"
            :page-count="mobile_page_count"
            pagination-label="User pages"
            :show-search="false"
            @update:current-page="set_mobile_page"
        />
    </div>
</div>
</div>
